import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../Translations';
import { ErrorPageBackground } from '../common/ErrorPageBackground';
import logo from '../../assets/error-page/logo.svg';
import notFoundIllustration from '../../assets/error-page/404-illustration.svg';

const NotFound: React.FC = () => {
  React.useEffect(() => {
    document.title = 'Page Not Found - ExecOnline';
  }, []);

  return (
    <div className="relative h-screen w-full overflow-hidden font-sans bg-[#fafafa]">
      <ErrorPageBackground />

      {/* Header */}
      <header
        className="absolute left-0 top-0 z-10 flex w-full items-center justify-between bg-white border-b border-gray-200 px-4 py-3 md:px-12 md:py-4"
        data-intercom-target="404-page-header"
      >
        <div className="flex items-center gap-8 md:gap-16">
          <a
            href="https://www.execonline.com"
            target="_blank"
            rel="noopener noreferrer"
            className="block h-[18px] w-[110px] md:h-[23.333px] md:w-[140px]"
          >
            <img src={logo} alt="ExecOnline" className="block h-full w-full" />
          </a>
        </div>
      </header>

      {/* Main content */}
      <div className="relative flex h-full flex-col items-center justify-center px-4 pt-16 md:px-0 md:pt-16">
        {/* Illustration */}
        <div className="mb-6 flex items-center justify-center md:mb-8">
          <img
            src={notFoundIllustration}
            alt="Person with question mark illustration"
            className="h-auto w-[280px] sm:w-[350px] md:w-[420px]"
            data-intercom-target="404-illustration"
          />
        </div>

        {/* Title */}
        <h1
          className="mb-3 px-4 text-center text-2xl font-semibold leading-tight text-black md:mb-4 md:text-[32px] md:leading-[36px]"
          data-intercom-target="404-page-title"
        >
          <T kind="error_page.not_found.title" />
        </h1>

        {/* Message */}
        <p
          className="mb-6 w-full max-w-[90%] px-4 text-center text-sm font-normal leading-relaxed text-black md:mb-8 md:w-[588px] md:text-[14px] md:leading-[24px]"
          data-intercom-target="404-page-message"
        >
          <T kind="error_page.not_found.message" />
        </p>

        {/* Button */}
        <div className="flex w-full max-w-[90%] flex-col items-center gap-4 px-4 sm:w-[280px] md:w-[250px]">
          <a
            href="/"
            className="flex w-full items-center justify-center rounded-md border border-solid border-teal-600 bg-white px-5 py-2.5 text-sm font-semibold text-teal-600 no-underline transition-colors hover:bg-teal-50 md:text-[14px]"
            data-intercom-target="404-dashboard-button"
          >
            <T kind="error_page.not_found.go_to_dashboard" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default observer(NotFound);
